import TreeNode from "../../../structures/TreeNode";
import random from "../../../utils/random";

/*
const pos0 = new TreeNode(
  0,
  false,
  -2345,
  1070,
  "No tengo ni idea de por dónde empezar para trámitar mi pensión.",
  0
);

const pos1 = new TreeNode(
  0,
  false,
  -2850,
  1370,
  "No tengo ni idea de por dónde empezar para trámitar mi pensión.",
  0
);

const pos2 = new TreeNode(
  0,
  false,
  -3415,
  1700,
  "No tengo ni idea de por dónde empezar para trámitar mi pensión.",
  0
);

const pos3 = new TreeNode(
  0,
  true,
  -3015,
  2185,
  "No tengo ni idea de por dónde empezar para trámitar mi pensión.",
  0
);

const pos4 = new TreeNode(
  0,
  true,
  -2765,
  2330,
  "No tengo ni idea de por dónde empezar para trámitar mi pensión.",
  0
);

const pos5 = new TreeNode(
  0,
  false,
  -2295,
  2610,
  "No tengo ni idea de por dónde empezar para trámitar mi pensión.",
  0
);

const pos6 = new TreeNode(
  0,
  true,
  -2665,
  2810,
  "No tengo ni idea de por dónde empezar para trámitar mi pensión.",
  0
);

const pos7 = new TreeNode(
  0,
  false,
  -3065,
  3080,
  "No tengo ni idea de por dónde empezar para trámitar mi pensión.",
  0
);

const pos8 = new TreeNode(
  0,
  true,
  -2840,
  3320,
  "No tengo ni idea de por dónde empezar para trámitar mi pensión.",
  0
);

const pos9 = new TreeNode(
  0,
  true,
  -2295,
  3460,
  "No tengo ni idea de por dónde empezar para trámitar mi pensión.",
  0
);

node1.quotes = [
  "“”",
  "“”",
  "“”",
];
*/

const node1 = new TreeNode(
  0,
  false,
  -2345,
  1070,
  "No sé por dónde empezar mi trámite de pensión.",
  0,
  "neutral",
);

node1.quotes = [
  "“Deberían de informarle a todos su clientes con tiempo los pasos y lo que tienen que hacer, así sería todo más fácil.”",
  "“No tení ni idea por dónde empezar el trámite para obtener mi pensión, a veces me mareaban tanto que creí que nunca me la darían.”",
];

const node1_1_1_1 = new TreeNode(2, false, -2850, 1370, "Llamando", 0);

const node1_1_1 = new TreeNode(
  1,
  false,
  -2850,
  1370,
  "¡Hola, está llamando a Profuturo! ¿En qué puedo apoyarlo?",
  0,
);

node1_1_1.quotes = [
  "“La señorita me explicó muy bien que era lo que tenía que hacer, excelente asesoría por parte de su personal.”",
  "“La persona que me contestó no me dijo con certeza que era lo que tenía que hacer y no resolvió ninguna de mis dudas.”",
];

const node1_1_2 = new TreeNode(
  0,
  false,
  -2850,
  1370,
  "Hola, tengo 65 años y quiero comenzar mi trámite de pensión.",
  0,
);

const node1_1_3 = new TreeNode(
  1,
  false,
  -2850,
  1370,
  "Claro, ¿en qué año empezó a cotizar en el IMSS?",
  0,
);

const node1_1_4 = new TreeNode(
  0,
  false,
  -2850,
  1370,
  "No lo sé, ¿cómo puedo averiguarlo?",
  0,
);

const node1_1_5 = new TreeNode(
  1,
  false,
  -2850,
  1370,
  "Me puede ayudar a revisar su último Estado de Cuenta, por favor. En la parte superior indica a qué ley pertenece.",
  0,
);

/*
const node1_1_6 = new TreeNode(
  2,
  false,
  -2850,
  1370,
  "Juego 1 (Próximamente)",
  0
);
*/

const node1_1_7 = new TreeNode(
  0,
  false,
  -2850,
  1370,
  "Dice que pertenezco a la Ley 73. ¿Qué significa?",
  0,
);

const node1_1_8 = new TreeNode(
  1,
  false,
  -2850,
  1370,
  "Que cotizó antes de julio de 1997.",
  0,
);

const node1_1_9 = new TreeNode(
  0,
  false,
  -2850,
  1370,
  "¿Eso es importante? ¿Qué debo hacer? ¿Cuáles son los requisitos?",
  0,
);

const node1_2_1 = new TreeNode(
  0,
  false,
  -3415,
  1700,
  "Vi que debo pertenecer a una de las dos leyes, pero no sé cuál me aplica.",
  0,
);

node1_2_1.quotes = [
  "“En su página no viene nada de información.”",
  "“En su blog encontré una nota muy buena con todos los requisitos, pero, no me dice qué hacer ni nada, deberían de complementarla y compartir esa nota.”",
];

const node1_2_2 = new TreeNode(
  0,
  false,
  -3415,
  1700,
  "Hay una página del IMSS donde puedo descargar una constancia, seguro ahí encontraré la fecha en la que empecé a trabajar y sabré a que ley pertenezco.",
  0,
);

/*
const node1_2_3 = new TreeNode(
  0,
  false,
  -3415,
  1700,
  "Juego 1 (Próximamente)",
  0
);
*/

const node1_2_4 = new TreeNode(
  0,
  false,
  -3415,
  1700,
  "Listo, empecé a trabajar en 1994, así que me corresponde la ley 73.",
  1,
);

const node1_2_5 = new TreeNode(
  0,
  false,
  -3415,
  1700,
  "¿Y ahora qué hago? Llamaré a Profuturo para pedir más información.",
  0,
);

const node1_2_5_1 = new TreeNode(2, false, -3415, 1700, "Llamando", 0);

const node1_2_6_1 = new TreeNode(
  1,
  false,
  -2850,
  1370,
  "¡Hola, está llamando a Profuturo! ¿En qué puedo apoyarlo?",
  0,
);

const node1_2_6_2 = new TreeNode(
  0,
  false,
  -2850,
  1370,
  "Hola, tengo 65 años y quiero comenzar mi trámite de pensión.",
  0,
);

const node1_2_6_3 = new TreeNode(
  1,
  false,
  -2850,
  1370,
  "Claro, ¿en qué año empezó a cotizar en el IMSS?",
  0,
);

const node1_2_6_4 = new TreeNode(
  0,
  false,
  -2850,
  1370,
  "Empecé en 1994, por lo que me aplica la Ley 73. Quiero saber qué hacer y qué requisitos debo cumplir.",
  0,
);

const node1_3_1 = new TreeNode(
  1,
  false,
  -2850,
  1370,
  "Para pensionarse por Ley 73 necesita:\n1. Tener 65 años.\n2. No estar cotizando en el IMSS.\n3. Al menos 500 semanas cotizadas.\n4. Estar dentro del periodo de conservación de derechos.",
  0,
);

node1_3_1.quotes = [
  "“Te dicen que hacer, pero no ubican que es un tema desconocido y nos gustaría que nos acompañaran más.”",
];

const node1_3_2 = new TreeNode(
  0,
  false,
  -2850,
  1370,
  "¿Cómo sé cuál es el periodo de conservación de derechos?",
  0,
);

const node1_3_3 = new TreeNode(
  1,
  false,
  -2850,
  1370,
  "Tu periodo de conservación de derechos es la cuarta parte de sus semanas cotizadas. Ejemplo, si trabajó 800 semanas, tiene 200 semanas (4 años) para pensionarse después de dejar de cotizar.",
  0,
);

const node1_3_4 = new TreeNode(
  0,
  false,
  -2850,
  1370,
  "Creo que cumplo con todo, pero ¿cómo sé si tengo 500 semanas cotizadas?",
  0,
);

const node1_3_4_1 = new TreeNode(
  1,
  false,
  -2850,
  1370,
  `Busque "Semanas cotizadas IMSS" en Internet. Con su CURP puede consultarlas ahora mismo.`,
  0,
);

const node1_3_4_2 = new TreeNode(
  0,
  false,
  -2850,
  1370,
  `Gracias, ya estoy ingresando al portal del IMSS`,
  0,
);

const node_juego_semanas_cotizadas = new TreeNode(
  2,
  false,
  -2850,
  1370,
  "Juego Semanas Cotizadas",
  0,
);
node_juego_semanas_cotizadas.game = 10;

const node_semanas_cotizadas_suficientes = new TreeNode(
  0,
  false,
  -2850,
  1370,
  "Tengo 750 semanas cotizadas, ¿eso significa que cumplo con todos los requisitos?",
  1,
  "smile",
);

const node_semanas_cotizadas_suficientes_1 = new TreeNode(
  1,
  false,
  -2850,
  1370,
  "Sí, ahora debemos verificar si tiene su Expediente de Identificación, ya que es necesario para el trámite.",
  0,
);

const node_semanas_cotizadas_suficientes_2 = new TreeNode(
  0,
  false,
  -2850,
  1370,
  "¿Cómo puedo saber si lo tengo?",
  0,
);

const node_semanas_cotizadas_suficientes_3 = new TreeNode(
  1,
  false,
  -2850,
  1370,
  "Estoy revisando en el sistema, le confirmo en un momento.",
  0,
);

const node_juego_encuentra_expediente = new TreeNode(
  2,
  false,
  -2850,
  1370,
  "Juego Encuentra Expediente",
  0,
);
node_juego_encuentra_expediente.game = 11;

const node_expediente_completo = new TreeNode(
  1,
  false,
  -2850,
  1370,
  "Como su Expediente está completo. Ahora debe de acudir a su subdelegación del IMSS y solicitar su trámite de pensión. Debe de llevar: \n1. Estado de Cuenta o Resumen de saldos \n2. Comprobante de cuenta para depósito \n3. Identificación oficial.",
  0,
);

const node_expediente_completo_1 = new TreeNode(
  0,
  false,
  -2850,
  1370,
  "Perfecto, muchas gracias",
  0,
);

const node_expediente_completo_2 = new TreeNode(
  2,
  false,
  -2850,
  1370,
  "Pasa 1 hora",
  1,
  "neutral",
);

const node_expediente_completo_3 = new TreeNode(
  2,
  true,
  -3015,
  2185,
  "Llegando a la subdelegación del IMSS",
  0,
);

const node_expediente_completo_3_1 = new TreeNode(
  0,
  true,
  -3015,
  2185,
  "Hola, quiero hacer mi trámite de pensión. Tengo todos mis documentos listos.",
  0,
);

const node_expediente_completo_4 = new TreeNode(
  1,
  true,
  -3015,
  2185,
  "Claro, ¿verificó que cumple con todos los requisitos?",
  0,
);

const node_expediente_completo_5 = new TreeNode(
  0,
  true,
  -3015,
  2185,
  "Sí, lo verifiqué antes con mi Afore.",
  0,
);

const node_expediente_completo_6 = new TreeNode(
  1,
  true,
  -3015,
  2185,
  "Perfecto, me puede compartir sus documentos, por favor.",
  0,
);

const node_expediente_completo_7 = new TreeNode(
  2,
  false,
  -3015,
  2185,
  "COMPARTIR DOCUMENTOS",
  0,
);

const node_juego_compartir_documentos = new TreeNode(
  2,
  false,
  -3015,
  2185,
  "COMPARTIR DOCUMENTOS",
  0,
);
node_juego_compartir_documentos.game = 19;

const node_expediente_completo_8 = new TreeNode(
  1,
  true,
  -3015,
  2185,
  "Todo está en orden. Revisaremos sus documentos y en máximo 30 días le llamaremos para darle su resolución de pensión.",
  0,
  "frustrated",
);

const node_expediente_completo_9 = new TreeNode(
  0,
  true,
  -3015,
  2185,
  "Muchas gracias, estaré al pendiente.",
  0,
);

const node_expediente_completo_10 = new TreeNode(
  0,
  false,
  -2345,
  1070,
  "¿Cómo esperan qué esté tranquila si tengo que esperar 30 días y no tengo ingresos?",
  0,
);

const node_expediente_completo_11 = new TreeNode(
  2,
  true,
  -2345,
  1070,
  "Después de 30 días",
  24 * 30,
);

const node_expediente_completo_12 = new TreeNode(
  0,
  false,
  -2345,
  1070,
  "¡Por fin! Ya me avisaron que mi resolución de pensión está lista.",
  0,
  "smile",
);

const node_expediente_completo_13 = new TreeNode(
  2,
  true,
  -2665,
  2810,
  "Llegando a la subdelegación del IMSS",
  0,
);

const node_expediente_completo_13_1 = new TreeNode(
  0,
  true,
  -2665,
  2810,
  "Hola, me avisaron que mi resolución de pensión ya está lista.",
  0,
);

const node_expediente_completo_14 = new TreeNode(
  1,
  true,
  -2665,
  2810,
  "Claro, aquí está.",
  0,
);

node_expediente_completo_14.dialogAnchor = { x: 10, y: 2.1 };

const node_expediente_completo_15 = new TreeNode(
  1,
  true,
  -2665,
  2810,
  "Perfecto, si está de acuerdo, solo falta su firma y listo.",
  0,
);

node_expediente_completo_15.dialogAnchor = { x: 10, y: 2.1 };

const node_expediente_completo_16 = new TreeNode(
  0,
  true,
  -2665,
  2810,
  "Sí, claro. Está muy bien.",
  0,
);

const node_expediente_completo_17 = new TreeNode(
  1,
  true,
  -2665,
  2810,
  "Perfecto, su pago será en 15 días. Para retirar su ahorro, haga el trámite con su Afore después de 10 días hábiles.",
  0,
  "frustrated",
);
node_expediente_completo_17.dialogAnchor = { x: 10, y: 2.1 };

const node_expediente_completo_18 = new TreeNode(
  0,
  true,
  -2665,
  2810,
  "De acuerdo, muchas gracias.",
  0,
);

const node_expediente_completo_19 = new TreeNode(
  0,
  true,
  -2665,
  2810,
  "Agendaré mi cita de una vez para ir a Profuturo.",
  0,
);

const node_expediente_completo_20 = new TreeNode(
  2,
  true,
  -2665,
  2810,
  "Después de 10 días",
  24 * 10,
);

const node_expediente_completo_21 = new TreeNode(
  1,
  false,
  -3065,
  3080,
  "Hola, bienvenida a Profuturo. Por favor, pase con el asistente para ser atendida.",
  0,
);
node_expediente_completo_21.dialogAnchor = { x: 10, y: 2.1 };

const node_expediente_completo_22 = new TreeNode(
  1,
  true,
  //-2665,
  //2810,
  -2840,
  3320,
  "Hola, ¿me comparte sus documentos, por favor?",
  0,
);
node_expediente_completo_22.dialogAnchor = { x: 10, y: 2.1 };

const node_expediente_completo_23 = new TreeNode(
  2,
  true,
  //-2665,
  //2810,
  -2840,
  3320,
  "COMPARTIR DOCUMENTOS",
  0,
);

const node_expediente_completo_24 = new TreeNode(
  1,
  true,
  //-2665,
  //2810,
  -2840,
  3320,
  "Vamos a llenar la solicitud.",
  0,
);
node_expediente_completo_24.dialogAnchor = { x: 10, y: 2.1 };

const node_expediente_completo_25 = new TreeNode(
  1,
  true,
  //-2665,
  //2810,
  -2840,
  3320,
  "Listo, su solicitud se envió. En 5 días hábiles recibirá la notificación con la respuesta.",
  0,
);
node_expediente_completo_25.dialogAnchor = { x: 10, y: 2.1 };

const node_expediente_completo_26 = new TreeNode(
  0,
  true,
  //-2665,
  //2810,
  -2840,
  3320,
  "Perfecto, muchas gracias.",
  0,
);

const node_expediente_completo_27 = new TreeNode(
  2,
  false,
  -2345,
  1070,
  "Después de 5 días",
  24 * 5,
  "angry",
);

const node_expediente_completo_28 = new TreeNode(
  0,
  false,
  -2345,
  1070,
  "Me avisaron que hubo un problema con mi información y debor ir de nuevo a Sucursal.",
  0,
);

const node_expediente_completo_29 = new TreeNode(
  2,
  false,
  -2345,
  1070,
  "Pasa 1 día más.\nAcudes a sucursal y solucionas el problema.",
  24,
);

const node_expediente_completo_30 = new TreeNode(
  0,
  false,
  -2345,
  1070,
  "Bueno, después de tanta vuelta, esperaré la notificación en 5 días hábiles. Confío en que todo saldrá bien.",
  0,
);

const node_expediente_completo_31 = new TreeNode(
  2,
  false,
  -2345,
  1070,
  "Pasan 5 días adicionales.",
  24 * 5,
);

const node_expediente_completo_32 = new TreeNode(
  100,
  false,
  -2345,
  1070,
  "REFERENCIA_DINERO",
  0,
  "happy",
);

const node_expediente_completo_33 = new TreeNode(
  1,
  false,
  -2345,
  1070,
  "Ya me confirmaron el depósito. Me tardé más de un mes, pero lo logré.",
  0,
  "happy",
);

node_expediente_completo_33.isLast = true;
node_expediente_completo_33.ending = 0;

/* Flujo incompleto */

const node_expediente_incompleto = new TreeNode(
  1,
  false,
  -2850,
  1370,
  "Veo que su Expediente no está completo. Tendrá que ir a sucursal. Le agendaré una cita.",
  0,
  "angry",
);

const node_expediente_incompleto_1 = new TreeNode(
  0,
  true,
  -2850,
  1370,
  "Muchas gracias.",
  0,
);

const node_expediente_incompleto_1_1 = new TreeNode(
  2,
  true,
  -2850,
  1370,
  "Pasan 15 días",
  24 * 15,
);

const node_expediente_incompleto_2 = new TreeNode(
  1,
  true,
  -3015,
  2185,
  "Hola, bienvenida a Profuturo. ¿Tiene cita?",
  0,
);

node_expediente_incompleto_2.dialogAnchor = { x: 15, y: 2.1 };

const node_expediente_incompleto_3 = new TreeNode(
  0,
  true,
  -3015,
  2185,
  "Hola, sí. Tengo cita para hacer mi Expediente de Identificación.",
  0,
);

const node_expediente_incompleto_4 = new TreeNode(
  1,
  true,
  -3015,
  2185,
  "Aquí está. Pase con el asistente, por favor.",
  0,
);
node_expediente_incompleto_4.dialogAnchor = { x: 15, y: 2.1 };

const node_expediente_incompleto_5 = new TreeNode(
  0,
  true,
  -2765,
  2330,
  "Hola, tengo cita para hacer mi Expediente de Identificación.",
  0,
);

const node_expediente_incompleto_6 = new TreeNode(
  1,
  true,
  -2765,
  2330,
  "Perfecto, ¿me comparte sus documentos?",
  0,
);
node_expediente_incompleto_6.dialogAnchor = { x: 10, y: 2.1 };

const node_expediente_incompleto_7 = new TreeNode(
  2,
  true,
  -2765,
  2330,
  "COMPARTIR DOCUMENTOS",
  0,
);

const node_juego_capturar_datos = new TreeNode(
  1,
  true,
  -2765,
  2330,
  "Juego Capturar INE",
  0,
  "angry",
);

node_juego_capturar_datos.game = 26;

const node_expediente_incompleto_8 = new TreeNode(
  1,
  true,
  -2765,
  2330,
  "Listo, en 5 días hábiles le llegará a su correo la confirmación de su expediente, posteriormente puede acudir al IMSS para continuar con su trámite.",
  0,
  "angry",
);

const node_expediente_incompleto_9 = new TreeNode(
  0,
  true,
  -2765,
  2330,
  "De acuerdo, muchas gracias.",
  0,
);

const node_expediente_incompleto_10 = new TreeNode(
  2,
  true,
  -2765,
  2330,
  "Después de 5 días",
  24 * 5,
);

const node_expediente_incompleto_11 = new TreeNode(
  0,
  false,
  -2345,
  1070,
  "No puede ser que tenga que pasar tanto tiempo para todo. Lo bueno es que ya me llegó la confirmación de la actualización de mi expediente.",
  0,
);

const node_expediente_incompleto_12 = new TreeNode(
  1,
  false,
  -2850,
  1370,
  "Hola, está hablando a Profuturo, ¿en qué puedo ayudarle?",
  0,
  "neutral",
);

const node_expediente_incompleto_13 = new TreeNode(
  0,
  false,
  -2850,
  1370,
  "Hola, ya me confirmaron que mi Expediente fue registrado. ¿Cuál es el siguiente paso para tramitar mi pensión?",
  0,
);

const node_semanas_cotizadas_insuficientes = new TreeNode(
  0,
  true,
  -2850,
  1370,
  "Tengo 458 semanas cotizadas, ¿qué significa?",
  1,
  "frustrated",
);

const node_semanas_cotizadas_insuficientes_1 = new TreeNode(
  0,
  false,
  -2850,
  1370,
  "Significa que el IMSS emitirá una negativa de pensión y podrá sacar todo su dinero de la Afore en una sola exhibición.",
  0,
);

const node_semanas_cotizadas_insuficientes_2 = new TreeNode(
  0,
  false,
  -2850,
  1370,
  "Entonces, ¿no tendré pensión? ",
  0,
);

const node_semanas_cotizadas_insuficientes_3 = new TreeNode(
  1,
  false,
  -2850,
  1370,
  "Es correcto. Únicamente se le entregará el dinero que tiene usted en su cuenta individual en la Afore.",
  0,
  "angry",
);

const node_semanas_cotizadas_insuficientes_4 = new TreeNode(
  0,
  false,
  -2850,
  1370,
  "Está bien, muchas gracias.",
  0,
);

const node_semanas_cotizadas_insuficientes_5 = new TreeNode(
  0,
  false,
  -3015,
  2185,
  "SIN_PENSIÓN",
  0,
);
node_semanas_cotizadas_insuficientes_5.isLast = true;
node_semanas_cotizadas_insuficientes_5.ending = 2;

const node_semanas_cotizadas_insuficientes_6 = new TreeNode(
  0,
  false,
  -3015,
  2185,
  "SIN_PENSIÓN",
  0,
);

const node1_4_1_1 = new TreeNode(
  0,
  false,
  -3015,
  2185,
  "Listo, al parecer tengo 458 semanas cotizadas, ¿esto qué significa?",
  0,
);

node1_4_1_1.quotes = [
  "“Cómo no te avisan antes que necesitas tener un mínimo de semanas cotizadas, ni si quiera sabía que era eso, ahora tengo que ver cómo las consigo, pagando o regresando a trabajar”",
];

const node1_4_1_2 = new TreeNode(
  1,
  false,
  -3015,
  2185,
  "Significa que el IMSS emitirá una negativa de pensión y podrás retirar el saldo de tu Afore en una sóla exhibición.",
  0,
);

const node1_4_1_3 = new TreeNode(
  0,
  false,
  -3015,
  2185,
  "Entonces, ¿no tendré pensión?",
  0,
);

const node1_4_1_4 = new TreeNode(1, false, -2850, 1370, "Así es.", 0);

const node1_4_1_5 = new TreeNode(
  0,
  false,
  -3015,
  2185,
  "Está bien, muchas gracias.",
  0,
);

const node1_4_2_0 = new TreeNode(
  2,
  false,
  -3015,
  2185,
  "Juego 1 (Próximamente)\nSumar Horas",
  0,
);

node1_4_2_0.game = 10;

const node1_4_2_1 = new TreeNode(
  0,
  false,
  -3015,
  2185,
  "Listo, al parecer tengo 750 semanas cotizadas, entonces, ¿si cumplo con todos los requisitos?",
  0,
);

node1_4_2_1.quotes = [
  "“Me llegó un mail con la información que necesitaba saber, lo que me aligeró más el trámite porque ya sabía si cumplía o no los requisitos”",
];

const node1_4_2_2 = new TreeNode(
  1,
  false,
  -3015,
  2185,
  "Así es, ahora lo que tenemos que hacer es verificar si tienes o no tu Expediente de Identificación, este es necesario para hacer el trámite de tu pensión.",
  0,
);

const node1_4_2_3 = new TreeNode(
  0,
  false,
  -3015,
  2185,
  "Entiendo, ¿cómo sé si lo tengo?",
  0,
);

const node1_4_2_4 = new TreeNode(
  1,
  false,
  -3015,
  2185,
  "Estoy verificando en nuestro sistemas, en un momento te confirmo.",
  0,
);

const node1_4_2_5 = new TreeNode(
  2,
  false,
  -3015,
  2185,
  "Juego 2 (Próximamente)\nPCs",
  0,
);

node1_4_2_5.game = 11;

const node1_5 = new TreeNode(0, false, -2850, 1370, "Final 1", 0);

node1_5.isLast = true;
node1_5.ending = 1;

const node1_6_1_1 = new TreeNode(
  1,
  false,
  -3015,
  2185,
  "Revisando el sistema veo que no tienes completo tu Expediente, por lo que tendrías que ir a sucursal a completarlo. Te agendaré una cita para el trámite.",
  0,
);

node1_6_1_1.quotes = [
  "“Esto del Expedinete siento que sólo es hacer tiempo para complicarte y no darte tu dinero, ¿por qué no me lo mencionaron antes?”",
];

const node1_6_1_2 = new TreeNode(0, false, -2850, 1370, "Muchas gracias.", 1);

const node1_6_2_1 = new TreeNode(
  1,
  false,
  -3015,
  2185,
  "Listo, veo que ya tienes completo tu Expediente, por lo que tendrías que ir al IMSS a la subdelegación que te corresponde y decir que quieres hacer tu trámite de pensión. Deberás asistir con los siguientes documentos:\n1. Estado de Cuenta / Resumen de saldos\n2. Comprobante de la cuenta a la que le van a depositar su pensión\n3. Identificación oficial",
  0,
);

const node1_6_2_2 = new TreeNode(
  0,
  false,
  -3015,
  2185,
  "Perfecto, muchas gracias.",
  1,
);

const node2_1 = new TreeNode(
  1,
  true,
  -3015,
  2185,
  "Hola, bienvenido a Profuturo, ¿tiene agendada una cita?",
  0,
);

node2_1.dialogAnchor = { y: 2.1 };

node2_1.quotes = [
  "“En sucursal se tardaron años en atenderme, y además fui varias veces porque me lo rechazaban por un tema de firmas, no puedo creer las vueltas que nos hacen dar.”",
];

const node2_2 = new TreeNode(
  0,
  true,
  -3015,
  2185,
  "Hola, sí tengo cita para hacer mi Expediente de Identificación.",
  0,
);

const node2_3 = new TreeNode(
  1,
  true,
  -3015,
  2185,
  "Aquí la tengo, por favor pasa con la asistente.",
  0,
);

node2_3.dialogAnchor = { y: 2.1 };

const node3_1 = new TreeNode(
  0,
  true,
  -2765,
  2330,
  "Hola, hice cita para hacer mi Expediente de Identificación.",
  0,
);

node1.quotes = [
  "“La señorita en sucursal fue muy amable, tuvo mucha paciencia al tomar mis huellas y me explicó cada parte del trámite.”",
];

const node3_2 = new TreeNode(
  1,
  true,
  -2765,
  2330,
  "Perfecto, ¿me podrías comparitr tus documentos?",
  0,
);

node3_2.dialogAnchor = { y: 2.1 };

const node3_3 = new TreeNode(0, true, -2765, 2330, "Aquí están.", 0);

const node3_4 = new TreeNode(
  2,
  true,
  -2765,
  2330,
  "Dialogo del trámite del expediente y juego 3 (Próximamente)\nCURP",
  0,
);

node3_4.game = 12;

///

const node3_4_1 = new TreeNode(
  1,
  true,
  -2765,
  2330,
  "Hay un problema con tu CURP, para arreglarlo tienes que ir a RENAPO, esto puede tardar hasta 70 días naturales en resolverse.",
  0,
);

node3_4_1.dialogAnchor = { y: 2.1 };

node3_4_1.quotes = [
  "“Nunca me había comentado del Expdiente y ahora resulta que lo necesito para hacer el trámite, sólo nos ponen trabas para no sacar el dinero.”",
];

const node3_4_2 = new TreeNode(0, true, -2765, 2330, "Muchas gracias.", 0);

const node3_4_3 = new TreeNode(
  0,
  false,
  -2295,
  2610,
  "Ya fui a RENAPO para resolver este tema, me comentaron que me dan resolución en 70 días, me urge el dinero y ya se detuvo todo por esto, pero bueno esperaré.",
  0,
);

const node3_4_4 = new TreeNode(
  2,
  false,
  -2295,
  2610,
  "70 días después.",
  70 * 24,
);

const node3_4_5 = new TreeNode(
  0,
  false,
  -2295,
  2610,
  "Listo, ya quedó resuelto lo de mi CURP, iré mañana a la sucursal de Profuturo para retomar el trámite.",
  0,
);

const node3_4_6 = new TreeNode(
  0,
  true,
  -3015,
  2185,
  "Hola, ya había empezado a hacer el trámite, pero tuve un problema con mi CURP, ya quedó resuelto y vengo a hacer mi trámite de Expediente.",
  24,
);

const node3_4_7 = new TreeNode(
  1,
  true,
  -3015,
  2185,
  "Perfecto, por favor pase con el asistente para ser atendido.",
  0,
);

node3_4_7.dialogAnchor = { y: 2.1 };

const node3_4_8 = new TreeNode(
  1,
  true,
  -2765,
  2330,
  "Buen día. Entiendo que viene a hacer su trámite de Expediente, ¿me puede compartir sus documentos por favor?",
  0,
);

node3_4_8.dialogAnchor = { y: 2.1 };

const node3_4_9 = new TreeNode(0, true, -2765, 2330, "Aquí están", 0);

///

const node3_5 = new TreeNode(
  1,
  true,
  -2765,
  2330,
  "Listo, en 5 días hábiles te deberá de llegar una confirmación a tu correo de que ya quedó tu Expediente. Con esto ya podrás ir al IMSS para inciar el trámite.",
  0,
);

node3_5.dialogAnchor = { y: 2.1 };

const node3_6 = new TreeNode(
  0,
  true,
  -2765,
  2330,
  "Perfecto, muchas gracias.",
  0,
);

const node4_1 = new TreeNode(
  2,
  false,
  -2295,
  2610,
  "Pasan los 5 días.",
  24 * 5,
);

node4_1.quotes = [
  "“No me llegó nunca una notificación, tuve que marcarles para saber el estetus de mi trámite.”",
];

const node4_2 = new TreeNode(
  0,
  false,
  -2295,
  2610,
  "Ya me llegó la confirmación de mi Expediente.",
  0,
);

const node5_1_1 = new TreeNode(
  1,
  false,
  -2850,
  1370,
  "Hola estás llamando a Profuturo, ¿en qué podemos ayudarte?",
  0,
);

const node5_1_2 = new TreeNode(
  0,
  false,
  -2850,
  1370,
  "Hola, me acaba de llegar la confirmación de que mi Expediente se registró con éxito, para tramitar mi pensión, ¿Cuál es el siguiente paso?",
  0,
);

const node5_1_3 = new TreeNode(
  1,
  false,
  -2850,
  1370,
  "Como ya tienes completo tu Expediente, lo que tendrías hacer es ir al IMSS a la subdelegación que te corresponde y decir que quieres hacer tu trámite de pensión. Deberás asistir con los siguientes documentos:\n1. Estado de Cuenta / Resumen de saldos\n2. Comprobante de la cuenta a la que le van a depositar su pensión\n3. Identificación oficial",
  0,
);

const node5_1_4 = new TreeNode(
  0,
  false,
  -2850,
  1370,
  "Perfecto, muchas gracias. ¿Me podrían compartir mi Estado de Cuenta o resumen de saldos?",
  0,
);

const node5_1_5 = new TreeNode(
  1,
  false,
  -2850,
  1370,
  "Claro, se lo hacemos llegar por correo electrónico.",
  0,
);

const node5_1_6 = new TreeNode(
  0,
  false,
  -2850,
  1370,
  "Perfecto, muchas gracias.",
  1,
);

const node5_2_1 = new TreeNode(
  0,
  true,
  -2665,
  2810,
  "Hola, quisiera hacer el trámite para pensionarme.",
  0,
);

node5_2_1.quotes = [
  "“Los trámites con el IMSS son tardados y confusos”",
  "“Me ayudó bastante que nen sucursal me dijeran exactamente lo que necesitaba y qué iba a pasar al momento de ir la IMSS para el trámite de pensión.”",
];

const node5_2_2 = new TreeNode(
  1,
  true,
  -2765,
  2330,
  "Claro, ¿verificaste que cumples con todos los requisitos?",
  0,
);

node5_2_2.dialogAnchor = { y: 2.1 };

const node5_2_3 = new TreeNode(
  0,
  false,
  -2765,
  2330,
  "Sí lo verifiqué anteriormente con mi Afore.",
  0,
);

const node5_2_4 = new TreeNode(
  1,
  true,
  -2665,
  2810,
  "Perfecto, compárteme tus documentos.",
  0,
);

node5_2_4.dialogAnchor = { y: 2.1 };

const node5_2_5 = new TreeNode(
  0,
  true,
  -2665,
  2810,
  "No sabía que tenía que traer documentos, ¿me podría decir cuáles necesito?",
  0,
);

const node5_2_6 = new TreeNode(
  1,
  true,
  -2665,
  2810,
  "Los documentos son necesarios para hacer el tramite, necesitas: Resumen de saldos o Estado de Cuenta de tu Afore, comprobante de la cuenta bancaria en la que se depositaría u pensión y una identificación oficial.",
  0,
);

node5_2_6.dialogAnchor = { y: 2.1 };

const node5_2_7 = new TreeNode(
  0,
  true,
  -2665,
  2810,
  "Perfecto, los consigo y regreso pronto.",
  0,
);

const node6_1 = new TreeNode(
  1,
  false,
  -2850,
  1370,
  "Hola estás llamando a Profuturo, ¿en qué podemos ayudarte?",
  0,
);

const node6_2 = new TreeNode(
  0,
  false,
  -2850,
  1370,
  "Hola, ¿me podrían compartir mi Estado de Cuenta o el Resumen de saldos de mi cuenta de Afore? Lo necesito para pensionarme.",
  0,
);

const node6_3 = new TreeNode(
  1,
  false,
  -2850,
  1370,
  "Claro, se lo hacemos llegar por correo electrónico.",
  0,
);

const node6_4 = new TreeNode(0, false, -2850, 1370, "Gracias.", 1);

const node7_1 = new TreeNode(
  0,
  true,
  -2665,
  2810,
  "Hola, quisiera hacer el trámite para pensionarme, tengo todos los documentos listos.",
  0,
);

const node7_2 = new TreeNode(
  1,
  true,
  -2665,
  2810,
  "Claro, ¿verificaste que cumples con todos los requisitos?",
  0,
);

node7_2.dialogAnchor = { y: 2.1 };

const node7_3 = new TreeNode(
  0,
  true,
  -2665,
  2810,
  "Sí lo verifiqué anteriormente con mi Afore.",
  0,
);

const node7_4 = new TreeNode(
  1,
  true,
  -2665,
  2810,
  "Perfecto, compárteme tus documentos.",
  0,
);

node7_4.dialogAnchor = { y: 2.1 };

const node7_5 = new TreeNode(0, true, -2665, 2810, "Aquí están.", 0);

const node7_5_1 = new TreeNode(
  0,
  true,
  -2665,
  2810,
  "Juego 4 (Próximamente)\nDocumentos",
  0,
);

node7_5_1.game = 2;

const node7_6 = new TreeNode(
  1,
  true,
  -2665,
  2810,
  "Veo que todo está en orden, revisaremos tu documentación a detalle y a más tadar en 30 días te estaremos buscando para que vengas por tu resolución de pensión.",
  0,
);

node7_6.dialogAnchor = { y: 2.1 };

const node7_7 = new TreeNode(
  0,
  true,
  -2665,
  2810,
  "Muchas gracias, estaré pendiente.",
  1,
);

const node8_1 = new TreeNode(
  0,
  false,
  -2295,
  2610,
  "No puedo creer que todavía tengo que esperar 30 días, no tengo ningún ingreso, ¿cómo esperan que esté tranquila?",
  0,
);

node8_1.quotes = [
  "“Es difícil e incómodo quedarte más de un mes sin ingreso, deberían de ser más empáticos y darnos algún adelanto.”",
];

const node8_2 = new TreeNode(
  2,
  false,
  -2295,
  2610,
  "Después de 30 días.",
  30 * 24,
);

const node8_3 = new TreeNode(
  0,
  false,
  -2295,
  2610,
  "Ya me llegó la notificación de que ya tienen lista mi resolución de pensión, ¡por fin!",
  0,
);

node8_3.quotes = [
  "“Es difícil e incómodo quedarte más de un mes sin ingreso, deberían de ser más empáticos y darnos algún adelanto.”",
];

const node9_1 = new TreeNode(
  0,
  true,
  -2665,
  2810,
  "Hola, me llegó un mensaje diciéndome que ya está lista mi resolución de pensión.",
  0,
);

const node9_2 = new TreeNode(1, true, -2665, 2810, "Claro, aquí está.", 0);

node9_2.dialogAnchor = { y: 2.1 };

const node9_3 = new TreeNode(
  1,
  false,
  -2665,
  2810,
  "Muy bien, entonces si está de acuerdo solo necesitaría tu firma y estaía todo listo.",
  0,
);

const node9_3_1 = new TreeNode(
  0,
  false,
  -2665,
  2810,
  "Sí claro, está muy bien.",
  0,
);

const node9_4 = new TreeNode(
  1,
  true,
  -2665,
  2810,
  "Perfecto, tu fecha de pago será en 15 días. Adicional, para retirar el ahorro que tienes en tu cuenta de Afore, tendrás que tramitarlo directamente con tu Afore después de 10 días hábiles.",
  0,
);

node9_4.dialogAnchor = { y: 2.1 };

const node9_5 = new TreeNode(
  0,
  true,
  -2665,
  2810,
  "Perfecto, muchas gracias.",
  1,
);

const node9_6 = new TreeNode(
  0,
  false,
  -2295,
  2610,
  "Agendaré cita de una vez para ir con Profuturo.",
  0,
);

const node10_1 = new TreeNode(
  1,
  false,
  -3065,
  3080,
  "Hola, bienvenido a Profuturo, ¿tiene agendada una cita?",
  10 * 24,
);

node10_1.dialogAnchor = { y: 2.1 };

const node10_2 = new TreeNode(
  0,
  false,
  -3065,
  3080,
  "Hola, sí tengo cita para hacer el trámite de Retiro Total.",
  0,
);

const node10_3 = new TreeNode(
  1,
  false,
  -3065,
  3080,
  "Aquí la tengo, por favor pasa con el asistente.",
  0,
);

node10_3.dialogAnchor = { y: 2.1 };

/**
 * 
  -2840,
  3320,
 */

const node11_1 = new TreeNode(
  0,
  true,
  -2840,
  3320,
  "Hola, hice cita para hacer mi Retiro Total.",
  0,
);

node11_1.quotes = [
  "“Al hacer el trámite de retiro, entendí que además de mi pensión tenía un ahorro aparte, nunca lo había entendido”",
];

const node11_2 = new TreeNode(
  1,
  true,
  -2840,
  3320,
  "Perfecto, ¿me podrías comparitr tus documentos?",
  0,
);

node11_2.dialogAnchor = { x: 10, y: 2.2 };

const node11_3 = new TreeNode(0, true, -2840, 3320, "Aquí están.", 0);

const node11_4 = new TreeNode(
  1,
  true,
  -2840,
  3320,
  "Vamos a llenar la solicitud.",
  0,
);

node11_4.dialogAnchor = { x: 10, y: 2.2 };

const node11_5 = new TreeNode(
  1,
  true,
  -2840,
  3320,
  "Listo, se mandará tu solicitud y en 5 días hábiles deberás de estar recibiendo una notificación con la conclusión de tu trámite.",
  0,
);

node11_5.dialogAnchor = { x: 10, y: 2.2 };

const node11_6 = new TreeNode(
  0,
  true,
  -2840,
  3320,
  "Perfecto, muchas gracias",
  1,
);

const node12 = new TreeNode(2, false, -2295, 3460, "Pasan 5 días hábiles", 0);

node12.quotes = [
  "“Porfuturo me ayudó con el trámite y todo quedó resuelto súper rápido.”",
];

const node12_1 = new TreeNode(
  0,
  false,
  -2295,
  3460,
  "Ya me llegó la confirmación del depósito de mi dinero. Me tardé más de un mes en hacer el trámite pero se logró.",
  5 * 24,
);

const node12_2_1 = new TreeNode(
  0,
  false,
  -2295,
  3460,
  "Me llegó una notificación de que hubo un problema con mi información tendré que ir a sucursal nuevamente.",
  5 * 24,
);

const node12_2_2 = new TreeNode(
  2,
  false,
  -2295,
  3460,
  "Cliente va a sucursal y arrgla el tema.",
  0,
);

const node12_2_3 = new TreeNode(
  0,
  false,
  -2295,
  3460,
  "Listo, esperaré nuevamente la notificación a los 5 días hábiales, confío en que todo estará bien.",
  0,
);

const node13 = new TreeNode(0, false, -2295, 3460, "Final", 0);

node13.isLast = true;
node13.ending = 0;

node1.descendants = [
  {
    node: node1_1_1_1,
    hint: "Llamaré a Profuturo para pedir información",
  },
  {
    node: node1_2_1,
    hint: "Buscaré en internet",
  },
];

node1_1_1_1.descendants = [
  {
    node: node1_1_1,
    hint: "Continuar",
  },
];

node1_1_1.descendants = [
  {
    node: node1_1_2,
    hint: "Continuar",
  },
];

node1_1_2.descendants = [
  {
    node: node1_1_3,
    hint: "Continuar",
  },
];

node1_1_3.descendants = [
  {
    node: node1_1_4,
    hint: "Continuar",
  },
];

node1_1_4.descendants = [
  {
    node: node1_1_5,
    hint: "Continuar",
  },
];

node1_1_5.descendants = [
  {
    node: node1_1_7,
    hint: "Continuar",
  },
];

/*
node1_1_6.descendants = [
  {
    node: node1_1_7,
    hint: "Continuar",
  },
];
*/

node1_1_7.descendants = [
  {
    node: node1_1_8,
    hint: "Continuar",
  },
];

node1_1_8.descendants = [
  {
    node: node1_1_9,
    hint: "Continuar",
  },
];

node1_1_9.descendants = [
  {
    node: node1_3_1,
    hint: "Continuar",
  },
];

node1_2_1.descendants = [
  {
    node: node1_2_2,
    hint: "Continuar",
  },
];

node1_2_2.descendants = [
  {
    node: node1_2_4,
    hint: "Continuar",
  },
];

/*
node1_2_3.descendants = [
  {
    node: node1_2_4,
    hint: "Continuar",
  },
];
*/

node1_2_4.descendants = [
  {
    node: node1_2_5,
    hint: "Continuar",
  },
];

node1_2_5.descendants = [
  {
    node: node1_2_5_1,
    hint: "Continuar",
  },
];

node1_2_5_1.descendants = [
  {
    node: node1_2_6_1,
    hint: "Continuar",
  },
];

node1_2_6_1.descendants = [
  {
    node: node1_2_6_2,
    hint: "Continuar",
  },
];

node1_2_6_2.descendants = [
  {
    node: node1_2_6_3,
    hint: "Continuar",
  },
];

node1_2_6_3.descendants = [
  {
    node: node1_2_6_4,
    hint: "Continuar",
  },
];

node1_2_6_4.descendants = [
  {
    node: node1_3_1,
    hint: "Continuar",
  },
];

node1_3_1.descendants = [
  {
    node: node1_3_2,
    hint: "Continuar",
  },
];

node1_3_2.descendants = [
  {
    node: node1_3_3,
    hint: "Continuar",
  },
];

node1_3_3.descendants = [
  {
    node: node1_3_4,
    hint: "Continuar",
  },
];

node1_3_4.descendants = [
  {
    node: node1_3_4_1,
    hint: "Continuar",
  },
];

node1_3_4_1.descendants = [
  {
    node: node_juego_semanas_cotizadas,
    hint: "Continuar",
  },
];

node1_3_4_2.descendants = [
  {
    node: node1_4_1_1,
    hint: "Continuar",
  },
];

node_juego_semanas_cotizadas.descendants = [
  {
    node: node_semanas_cotizadas_suficientes,
    hint: "Continuar",
  },
  {
    node: node_semanas_cotizadas_insuficientes,
    hint: "Continuar",
  },
];

node_juego_semanas_cotizadas.conditionalDescendants = true;

node_semanas_cotizadas_suficientes.descendants = [
  {
    node: node_semanas_cotizadas_suficientes_1,
    hint: "Continuar",
  },
];

node_semanas_cotizadas_suficientes_1.descendants = [
  {
    node: node_semanas_cotizadas_suficientes_2,
    hint: "Continuar",
  },
];

node_semanas_cotizadas_suficientes_2.descendants = [
  {
    node: node_semanas_cotizadas_suficientes_3,
    hint: "Continuar",
  },
];

node_semanas_cotizadas_suficientes_3.descendants = [
  {
    node: node_juego_encuentra_expediente,
    hint: "Continuar",
  },
];

node_juego_encuentra_expediente.descendants = [
  {
    node: node_expediente_completo,
    hint: "Continuar",
  },
  {
    node: node_expediente_incompleto,
    hint: "Continuar",
  },
];

node_juego_encuentra_expediente.conditionalDescendants = true;

node_expediente_completo.descendants = [
  {
    node: node_expediente_completo_1,
    hint: "Continuar",
  },
];

node_expediente_completo_1.descendants = [
  {
    node: node_expediente_completo_2,
    hint: "Continuar",
  },
];

node_expediente_completo_2.descendants = [
  {
    node: node_expediente_completo_3,
    hint: "Continuar",
  },
];

node_expediente_completo_3.descendants = [
  {
    node: node_expediente_completo_3_1,
    hint: "Continuar",
  },
];

node_expediente_completo_3_1.descendants = [
  {
    node: node_expediente_completo_4,
    hint: "Continuar",
  },
];

node_expediente_completo_4.descendants = [
  {
    node: node_expediente_completo_5,
    hint: "Continuar",
  },
];

node_expediente_completo_5.descendants = [
  {
    node: node_expediente_completo_6,
    hint: "Continuar",
  },
];

node_expediente_completo_6.descendants = [
  {
    node: node_expediente_completo_7,
    hint: "Continuar",
  },
];

node_expediente_completo_7.descendants = [
  {
    node: node_juego_compartir_documentos,
    hint: "Continuar",
  },
];

node_juego_compartir_documentos.descendants = [
  {
    node: node_expediente_completo_8,
    hint: "Continuar",
  },
];

node_expediente_completo_8.descendants = [
  {
    node: node_expediente_completo_9,
    hint: "Continuar",
  },
];

node_expediente_completo_9.descendants = [
  {
    node: node_expediente_completo_10,
    hint: "Continuar",
  },
];

node_expediente_completo_10.descendants = [
  {
    node: node_expediente_completo_11,
    hint: "Continuar",
  },
];

node_expediente_completo_11.descendants = [
  {
    node: node_expediente_completo_12,
    hint: "Continuar",
  },
];

node_expediente_completo_12.descendants = [
  {
    node: node_expediente_completo_13,
    hint: "Continuar",
  },
];

node_expediente_completo_13.descendants = [
  {
    node: node_expediente_completo_13_1,
    hint: "Continuar",
  },
];

node_expediente_completo_13_1.descendants = [
  {
    node: node_expediente_completo_14,
    hint: "Continuar",
  },
];

node_expediente_completo_14.descendants = [
  {
    node: node_expediente_completo_15,
    hint: "Continuar",
  },
];

node_expediente_completo_15.descendants = [
  {
    node: node_expediente_completo_16,
    hint: "Continuar",
  },
];

node_expediente_completo_16.descendants = [
  {
    node: node_expediente_completo_17,
    hint: "Continuar",
  },
];

node_expediente_completo_17.descendants = [
  {
    node: node_expediente_completo_18,
    hint: "Continuar",
  },
];

node_expediente_completo_18.descendants = [
  {
    node: node_expediente_completo_19,
    hint: "Continuar",
  },
];

node_expediente_completo_19.descendants = [
  {
    node: node_expediente_completo_20,
    hint: "Continuar",
  },
];

node_expediente_completo_20.descendants = [
  {
    node: node_expediente_completo_21,
    hint: "Continuar",
  },
];

node_expediente_completo_21.descendants = [
  {
    node: node_expediente_completo_22,
    hint: "Continuar",
  },
];

node_expediente_completo_22.descendants = [
  {
    node: node_expediente_completo_23,
    hint: "Continuar",
  },
];

node_expediente_completo_23.descendants = [
  {
    node: node_expediente_completo_24,
    hint: "Continuar",
  },
];

node_expediente_completo_24.descendants = [
  {
    node: node_expediente_completo_25,
    hint: "Continuar",
  },
];

node_expediente_completo_25.descendants = [
  {
    node: node_expediente_completo_26,
    hint: "Continuar",
  },
];

node_expediente_completo_26.descendants = [
  {
    node: node_expediente_completo_27,
    hint: "Continuar",
  },
];

node_expediente_completo_27.descendants = [
  {
    node: node_expediente_completo_28,
    hint: "Continuar",
  },
];

node_expediente_completo_28.descendants = [
  {
    node: node_expediente_completo_29,
    hint: "Continuar",
  },
];

node_expediente_completo_29.descendants = [
  {
    node: node_expediente_completo_30,
    hint: "Continuar",
  },
];

node_expediente_completo_30.descendants = [
  {
    node: node_expediente_completo_31,
    hint: "Continuar",
  },
];

node_expediente_completo_31.descendants = [
  {
    node: node_expediente_completo_32,
    hint: "Continuar",
  },
];

node_expediente_completo_32.descendants = [
  {
    node: node_expediente_completo_33,
    hint: "Continuar",
  },
];

/* Flujo incompleto */

node_expediente_incompleto.descendants = [
  {
    node: node_expediente_incompleto_1,
    hint: "Continuar",
  },
];

node_expediente_incompleto_1.descendants = [
  {
    node: node_expediente_incompleto_1_1,
    hint: "Continuar",
  },
];

node_expediente_incompleto_1_1.descendants = [
  {
    node: node_expediente_incompleto_2,
    hint: "Continuar",
  },
];

node_expediente_incompleto_2.descendants = [
  {
    node: node_expediente_incompleto_3,
    hint: "Continuar",
  },
];

node_expediente_incompleto_3.descendants = [
  {
    node: node_expediente_incompleto_4,
    hint: "Continuar",
  },
];

node_expediente_incompleto_4.descendants = [
  {
    node: node_expediente_incompleto_5,
    hint: "Continuar",
  },
];

node_expediente_incompleto_5.descendants = [
  {
    node: node_expediente_incompleto_6,
    hint: "Continuar",
  },
];

node_expediente_incompleto_6.descendants = [
  {
    node: node_expediente_incompleto_7,
    hint: "Continuar",
  },
];

node_expediente_incompleto_7.descendants = [
  {
    node: node_juego_capturar_datos,
    hint: "Continuar",
  },
];

node_juego_capturar_datos.descendants = [
  {
    node: node_expediente_incompleto_8,
    hint: "Continuar",
  },
];

node_expediente_incompleto_8.descendants = [
  {
    node: node_expediente_incompleto_9,
    hint: "Continuar",
  },
];

node_expediente_incompleto_9.descendants = [
  {
    node: node_expediente_incompleto_10,
    hint: "Continuar",
  },
];

node_expediente_incompleto_10.descendants = [
  {
    node: node_expediente_incompleto_11,
    hint: "Continuar",
  },
];

node_expediente_incompleto_11.descendants = [
  {
    node: node_expediente_incompleto_12,
    hint: "Llamaré a Profuturo para ver cuáles son los siguientes pasos",
  },
  {
    node: node_expediente_completo_3,
    hint: "Iré al IMSS a comenzar con mi trámite.",
  },
];

node_expediente_incompleto_12.descendants = [
  {
    node: node_expediente_incompleto_13,
    hint: "Continuar",
  },
];

node_expediente_incompleto_13.descendants = [
  {
    node: node_expediente_completo,
    hint: "Continuar",
  },
];

node_semanas_cotizadas_insuficientes.descendants = [
  {
    node: node_semanas_cotizadas_insuficientes_1,
    hint: "Continuar",
  },
];

node_semanas_cotizadas_insuficientes_1.descendants = [
  {
    node: node_semanas_cotizadas_insuficientes_2,
    hint: "Continuar",
  },
];

node_semanas_cotizadas_insuficientes_2.descendants = [
  {
    node: node_semanas_cotizadas_insuficientes_3,
    hint: "Continuar",
  },
];

node_semanas_cotizadas_insuficientes_3.descendants = [
  {
    node: node_semanas_cotizadas_insuficientes_4,
    hint: "Continuar",
  },
];

node_semanas_cotizadas_insuficientes_4.descendants = [
  {
    node: node_semanas_cotizadas_insuficientes_5,
    hint: "Continuar",
  },
];

node_semanas_cotizadas_insuficientes_5.descendants = [
  {
    node: node_semanas_cotizadas_insuficientes_6,
    hint: "Continuar",
  },
];

node1_4_1_1.descendants = [
  {
    node: node1_4_1_2,
    hint: "Continuar",
  },
];

node1_4_1_2.descendants = [
  {
    node: node1_4_1_3,
    hint: "Continuar",
  },
];

node1_4_1_3.descendants = [
  {
    node: node1_4_1_4,
    hint: "Continuar",
  },
];

node1_4_1_4.descendants = [
  {
    node: node1_4_1_5,
    hint: "Continuar",
  },
];

node1_4_1_5.descendants = [
  {
    node: node1_5,
    hint: "Continuar",
  },
];

node1_4_2_0.descendants = [
  {
    node: node1_4_2_1,
    hint: "Continuar",
  },
  {
    node: node1_4_1_1,
    hint: "Continuar",
  },
];

node1_4_2_1.descendants = [
  {
    node: node1_4_2_2,
    hint: "Continuar",
  },
];

node1_4_2_2.descendants = [
  {
    node: node1_4_2_3,
    hint: "Continuar",
  },
];

node1_4_2_3.descendants = [
  {
    node: node1_4_2_4,
    hint: "Continuar",
  },
];

node1_4_2_4.descendants = [
  {
    node: node1_4_2_5,
    hint: "Continuar",
  },
];

node1_4_2_5.descendants = [
  {
    node: node1_6_1_1,
    hint: "No tiene el expediente",
  },
  {
    node: node1_6_2_1,
    hint: "Tiene el expediente",
  },
];

node1_6_1_1.descendants = [
  {
    node: node1_6_1_2,
    hint: "Continuar",
  },
];

node1_6_1_2.descendants = [
  {
    node: node2_1,
    hint: "Continuar",
  },
];

node1_6_2_1.descendants = [
  {
    node: node1_6_2_2,
    hint: "Continuar",
  },
];

node1_6_2_2.descendants = [
  {
    node: node7_1,
    hint: "Continuar",
  },
];

node2_1.descendants = [
  {
    node: node2_2,
    hint: "Continuar",
  },
];

node2_2.descendants = [
  {
    node: node2_3,
    hint: "Continuar",
  },
];

node2_3.descendants = [
  {
    node: node3_1,
    hint: "Continuar",
  },
];

node3_1.descendants = [
  {
    node: node3_2,
    hint: "Continuar",
  },
];

node3_2.descendants = [
  {
    node: node3_3,
    hint: "Continuar",
  },
];

node3_3.descendants = [
  {
    node: node3_4,
    hint: "Continuar",
  },
];

node3_4.descendants = [
  {
    node: node3_4_1,
    hint: "Continuar",
  },
  {
    node: node3_5,
    hint: "Continuar",
  },
];

node3_4_1.descendants = [
  {
    node: node3_4_2,
    hint: "Continuar",
  },
];

node3_4_2.descendants = [
  {
    node: node3_4_3,
    hint: "Continuar",
  },
];

node3_4_3.descendants = [
  {
    node: node3_4_4,
    hint: "Continuar",
  },
];

node3_4_4.descendants = [
  {
    node: node3_4_5,
    hint: "Continuar",
  },
];

node3_4_5.descendants = [
  {
    node: node3_4_6,
    hint: "Continuar",
  },
];

node3_4_6.descendants = [
  {
    node: node3_4_7,
    hint: "Continuar",
  },
];

node3_4_7.descendants = [
  {
    node: node3_4_8,
    hint: "Continuar",
  },
];

node3_4_8.descendants = [
  {
    node: node3_4_9,
    hint: "Continuar",
  },
];

node3_4_9.descendants = [
  {
    node: node3_5,
    hint: "Continuar",
  },
];

node3_5.descendants = [
  {
    node: node3_6,
    hint: "Continuar",
  },
];

node3_6.descendants = [
  {
    node: node4_1,
    hint: "Continuar",
  },
];

node4_1.descendants = [
  {
    node: node4_2,
    hint: "Continuar",
  },
];

node4_2.descendants = [
  {
    node: node5_1_1,
    hint: "Marcaré al Profuturo para ver cuáles son los siguientes pasos",
  },
  {
    node: node5_2_1,
    hint: "Iré al IMSS para tramitar mi Expediente",
  },
];

node5_1_1.descendants = [
  {
    node: node5_1_2,
    hint: "Continuar",
  },
];

node5_1_2.descendants = [
  {
    node: node5_1_3,
    hint: "Continuar",
  },
];

node5_1_3.descendants = [
  {
    node: node5_1_4,
    hint: "Continuar",
  },
];

node5_1_4.descendants = [
  {
    node: node5_1_5,
    hint: "Continuar",
  },
];

node5_1_5.descendants = [
  {
    node: node5_1_6,
    hint: "Continuar",
  },
];

node5_1_6.descendants = [
  {
    node: node7_1,
    hint: "Continuar",
  },
];

node5_2_1.descendants = [
  {
    node: node5_2_2,
    hint: "Continuar",
  },
];

node5_2_2.descendants = [
  {
    node: node5_2_3,
    hint: "Continuar",
  },
];

node5_2_3.descendants = [
  {
    node: node5_2_4,
    hint: "Continuar",
  },
];

node5_2_4.descendants = [
  {
    node: node5_2_5,
    hint: "Continuar",
  },
];

node5_2_5.descendants = [
  {
    node: node5_2_6,
    hint: "Continuar",
  },
];

node5_2_6.descendants = [
  {
    node: node5_2_7,
    hint: "Continuar",
  },
];

node5_2_7.descendants = [
  {
    node: node6_1,
    hint: "Continuar",
  },
];

node6_1.descendants = [
  {
    node: node6_2,
    hint: "Continuar",
  },
];

node6_2.descendants = [
  {
    node: node6_3,
    hint: "Continuar",
  },
];

node6_3.descendants = [
  {
    node: node6_4,
    hint: "Continuar",
  },
];

node6_4.descendants = [
  {
    node: node7_1,
    hint: "Continuar",
  },
];

node7_1.descendants = [
  {
    node: node7_2,
    hint: "Continuar",
  },
];

node7_2.descendants = [
  {
    node: node7_3,
    hint: "Continuar",
  },
];

node7_3.descendants = [
  {
    node: node7_4,
    hint: "Continuar",
  },
];

node7_4.descendants = [
  {
    node: node7_5,
    hint: "Continuar",
  },
];

node7_5.descendants = [
  {
    node: node7_6,
    hint: "Continuar",
  },
];

node7_5_1.descendants = [
  {
    node: node7_6,
    hint: "Continuar",
  },
];

node7_6.descendants = [
  {
    node: node7_7,
    hint: "Continuar",
  },
];

node7_7.descendants = [
  {
    node: node8_1,
    hint: "Continuar",
  },
];

node8_1.descendants = [
  {
    node: node8_2,
    hint: "Continuar",
  },
];

node8_2.descendants = [
  {
    node: node8_3,
    hint: "Continuar",
  },
];

node8_3.descendants = [
  {
    node: node9_1,
    hint: "Continuar",
  },
];

node9_1.descendants = [
  {
    node: node9_2,
    hint: "Continuar",
  },
];

node9_2.descendants = [
  {
    node: node9_3,
    hint: "Continuar",
  },
];

node9_3.descendants = [
  {
    node: node9_3_1,
    hint: "Continuar",
  },
];

node9_3_1.descendants = [
  {
    node: node9_4,
    hint: "Continuar",
  },
];

node9_4.descendants = [
  {
    node: node9_5,
    hint: "Continuar",
  },
];

node9_5.descendants = [
  {
    node: node9_6,
    hint: "Continuar",
  },
];

node9_6.descendants = [
  {
    node: node10_1,
    hint: "Continuar",
  },
];

node10_1.descendants = [
  {
    node: node10_2,
    hint: "Continuar",
  },
];

node10_2.descendants = [
  {
    node: node10_3,
    hint: "Continuar",
  },
];

node10_3.descendants = [
  {
    node: node11_1,
    hint: "Continuar",
  },
];

node11_1.descendants = [
  {
    node: node11_2,
    hint: "Continuar",
  },
];

node11_2.descendants = [
  {
    node: node11_3,
    hint: "Continuar",
  },
];

node11_3.descendants = [
  {
    node: node11_4,
    hint: "Continuar",
  },
];

node11_4.descendants = [
  {
    node: node11_5,
    hint: "Continuar",
  },
];

node11_5.descendants = [
  {
    node: node11_6,
    hint: "Continuar",
  },
];

node11_6.descendants = [
  {
    node: node12,
    hint: "Continuar",
  },
];

node11_6.descendants = [
  {
    node: random([node12_1, node12_1, node12_2_1]),
    hint: "Continuar",
  },
];

node12_1.descendants = [
  {
    node: node13,
    hint: "Continuar",
  },
];

node12_2_1.descendants = [
  {
    node: node12_2_2,
    hint: "Continuar",
  },
];

node12_2_2.descendants = [
  {
    node: node12_2_3,
    hint: "Continuar",
  },
];

node12_2_3.descendants = [
  {
    node: node12_1,
    hint: "Continuar",
  },
];

export default node1;
